'use strict';

var FareLadderChartController = function FareLadderChartController($scope, $timeout) {
  $scope.$watch('fareLadderData', function (data) {
    if (data && data.fareLadderData.length > 0) {
      $timeout(function () {
        $scope.renderChart(data);
      }, 0);
    }
  });
};
FareLadderChartController.$inject = ['$scope', '$timeout'];
module.exports = FareLadderChartController;